type LogLevel = "debug" | "info" | "warn" | "error";

class Logger {
  private readonly isDevMode: boolean;

  constructor() {
    // Assuming 'development' is the dev mode identifier
    this.isDevMode = process.env.NODE_ENV === "development";
  }

  private log(level: LogLevel, ...args: any[]): void {
    if (level === "debug" && !this.isDevMode) {
      return; // Ignore debug logs unless in development mode
    }

    switch (level) {
      case "debug":
        // eslint-disable-next-line no-console
        console.debug(...args);
        break;
      case "info":
        // eslint-disable-next-line no-console
        console.info(...args);
        break;
      case "warn":
        // eslint-disable-next-line no-console
        console.warn(...args);
        break;
      case "error":
        // eslint-disable-next-line no-console
        console.error(...args);
        break;
      default:
        // eslint-disable-next-line no-console
        console.log(...args);
        break;
    }
  }

  public debug(...args: any[]): void {
    this.log("debug", ...args);
  }

  public info(...args: any[]): void {
    this.log("info", ...args);
  }

  public warn(...args: any[]): void {
    this.log("warn", ...args);
  }

  public error(...args: any[]): void {
    this.log("error", ...args);
  }
}

// Exporting a single instance of Logger
export const logger = new Logger();
